import { AntenApps, PageContent } from "src/models";
import { PagesType } from "../types";
import { createAction } from "./create.action";

export namespace PagesAction {

    export const requestAboutUs = () => createAction(PagesType.REQUEST_ABOUT_US_CONTENT);
    export const setAboutUs = (content: PageContent) => createAction(PagesType.SET_ABOUT_US_CONTENT, content);

    export const requestPackageGuide = () => createAction(PagesType.REQUEST_PACKAGE_GUIDE_CONTENT);
    export const setPackageGuide = (content: PageContent) => createAction(PagesType.SET_PACKAGE_GUIDE_CONTENT, content);

    export const requestAppLinks = () => createAction(PagesType.REQUEST_APP_LINKS_CONTENT);
    export const setAppLinks = (content: AntenApps) => createAction(PagesType.SET_APP_LINKS_CONTENT, content);

}